import Vue from "vue";
import UserJourneyService from "@/services/UserJourneyService";
import store from "@/store";
import { router } from "@/router";

const state = {
  triggersList: [],
  triggersListCopy: [],
  actionsList: [],
  actionsListCopy: [],
  flowControlsList: [],
  flowControlsListCopy: [],
  conditionsList: [],
  conditionsListCopy: [],
  actionDataTypes: [],
  conditionRules: [],
  emailCampaigns: [],
  smsTemplates: [],
  segments: [],
  userJourneyList: [],
  userJourneyCopyList: [],
  selectedStatus: "All"
};

const mutations = {
  SET_TRIGGER_LIST_DATA: (state, payload) => {
    state.triggersList = payload;
    state.triggersListCopy = payload;
  },
  SET_ACTIONS_LIST_DATA: (state, payload) => {
    state.actionsList = payload;
    state.actionsListCopy = payload;
  },
  SET_FLOW_CONTROL_LIST_DATA: (state, payload) => {
    state.flowControlsList = payload;
    state.flowControlsListCopy = payload;
  },
  SET_CONDITIONS_LIST_DATA: (state, payload) => {
    state.conditionsList = payload;
    state.conditionsListCopy = payload;
  },
  SET_ACTION_DATA_TYPES: (state, payload) => {
    state.actionDataTypes = payload;
  },
  SET_CONDITION_RULES: (state, payload) => {
    state.conditionRules = payload;
  },
  SET_EMAIL_CAMPAIGN_LIST: (state, payload) => {
    state.emailCampaigns = payload;
  },
  SET_SMS_TEMPLATE_LIST: (state, payload) => {
    state.smsTemplates = payload;
  },
  SET_SEGMENTS_LIST: (state, payload) => {
    state.segments = payload;
  },
  SET_STATUS: (state, payload) => {
    state.selectedStatus = payload;
  },
  SET_USER_JOURNEY_LIST: (state, payload) => {
    state.userJourneyList = payload;
    state.userJourneyCopyList = payload;
  },
  ON_SEARCH_JOURNEY: (state, payload) => {
    state.userJourneyList = state.userJourneyCopyList.filter(x => {
      return x.user_journey_name.toLowerCase().includes(payload.toLowerCase());
    });
  },
  ON_SEARCH_CONTROL: (state, payload) => {
    state.search = payload;
    if (payload !== "") {
      state.triggersList = state.triggersListCopy.filter(x => {
        if (
          x.trigger_name &&
          x.trigger_name.toLowerCase().includes(payload.toLowerCase())
        ) {
          return x;
        }
      });

      state.actionsList = state.actionsListCopy.filter(x => {
        if (
          x.action_name &&
          x.action_name.toLowerCase().includes(payload.toLowerCase())
        ) {
          return x;
        }
      });

      state.conditionsList = state.conditionsListCopy.filter(x => {
        if (
          x.condition_name &&
          x.condition_name.toLowerCase().includes(payload.toLowerCase())
        ) {
          return x;
        }
      });

      state.flowControlsList = state.flowControlsListCopy.filter(x => {
        if (
          x.flow_control_name &&
          x.flow_control_name.toLowerCase().includes(payload.toLowerCase())
        ) {
          return x;
        }
      });
    } else {
      state.triggersList = state.triggersListCopy;
      state.actionsList = state.actionsListCopy;
      state.conditionsList = state.conditionsListCopy;
      state.flowControlsList = state.flowControlsListCopy;
    }
  }
};

const actions = {
  onSearchJoruney: ({ commit }, payload) => {
    commit("ON_SEARCH_JOURNEY", payload.target.value);
  },
  onSearchControl: ({ commit }, payload) => {
    commit("ON_SEARCH_CONTROL", payload);
  },
  getTriggersList: async ({ commit }, payload) => {
    let loader = Vue.$loading.show();
    await UserJourneyService.GetTriggersList()
      .then(async response => {
        loader.hide();
        const { data } = response;
        if (data.status) {
          commit("SET_TRIGGER_LIST_DATA", data.Records);
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on User Journey", error);
      });
  },
  getActionsList: async ({ commit }, payload) => {
    let loader = Vue.$loading.show();
    await UserJourneyService.GetActionsList()
      .then(async response => {
        loader.hide();
        const { data } = response;
        if (data.status) {
          commit("SET_ACTIONS_LIST_DATA", data.Records);
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on User Journey", error);
      });
  },
  getFlowControlsList: async ({ commit }, payload) => {
    let loader = Vue.$loading.show();
    await UserJourneyService.GetFlowControlsList()
      .then(async response => {
        loader.hide();
        const { data } = response;
        if (data.status) {
          commit("SET_FLOW_CONTROL_LIST_DATA", data.Records);
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on User Journey", error);
      });
  },
  getConditionsList: async ({ commit }, payload) => {
    let loader = Vue.$loading.show();
    await UserJourneyService.GetConditionsList()
      .then(async response => {
        loader.hide();
        const { data } = response;
        if (data.status) {
          commit("SET_CONDITIONS_LIST_DATA", data.Records);
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on User Journey", error);
      });
  },
  getActionDataType: async ({ commit }, payload) => {
    let loader = Vue.$loading.show();
    await UserJourneyService.GetActionDataTypes()
      .then(async response => {
        loader.hide();
        const { data } = response;
        if (data.status) {
          commit("SET_ACTION_DATA_TYPES", data.Records);
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on User Journey", error);
      });
  },
  getConditionRules: async ({ commit }, payload) => {
    let loader = Vue.$loading.show();
    await UserJourneyService.GetConditionRules()
      .then(async response => {
        loader.hide();
        const { data } = response;
        if (data.status) {
          commit("SET_CONDITION_RULES", data.Records);
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on User Journey", error);
      });
  },
  getEmailCampaignList: async ({ commit }, payload) => {
    // let loader = Vue.$loading.show();
    await UserJourneyService.GetEmailTemplateList()
      .then(async response => {
        // loader.hide();
        const { data } = response;
        if (data.status) {
          commit("SET_EMAIL_CAMPAIGN_LIST", data.Records);
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on User Journey", error);
      });
  },
  getSmsTemplateList: async ({ commit }, payload) => {
    // let loader = Vue.$loading.show();
    await UserJourneyService.GetSmsTemplateList()
      .then(async response => {
        // loader.hide();
        const { data } = response;
        if (data.status) {
          commit("SET_SMS_TEMPLATE_LIST", data.Records);
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on User Journey", error);
      });
  },
  getSegments: async ({ commit }, payload) => {
    // let loader = Vue.$loading.show();
    await UserJourneyService.GetSegments()
      .then(async response => {
        // loader.hide();
        const { data } = response;
        if (data.status) {
          commit("SET_SEGMENTS_LIST", data.Records);
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on User Journey", error);
      });
  },
  onFetchUserJourney: async ({ commit }, payload) => {
    let loader = Vue.$loading.show();
    let request_payload = {
      status: payload == "All" ? null : payload || null
    };
    await UserJourneyService.GetAllUserJourney(request_payload)
      .then(async response => {
        loader.hide();
        const { data } = response;
        if (data.status) {
          commit("SET_STATUS", payload);
          commit("SET_USER_JOURNEY_LIST", data.Records);
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on User Journey", error);
      });
  },
  addToUserJourney: async ({ commit }, payload) => {
    let loader = Vue.$loading.show();
    await UserJourneyService.AddUserJourney(payload)
      .then(async response => {
        loader.hide();
        const { data } = response;
        if (data.status) {
          router.push({ path: "/marketing-automation/user-journey" });
          Vue.toasted.show(data.message);
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        loader.hide();
        Vue.toasted.show("Catch Error on adding User Journey", error);
      });
  },
  onUpdateUserJourney: async ({ commit }, payload) => {
    let loader = Vue.$loading.show();
    await UserJourneyService.UpdateUserJourney(payload)
      .then(async response => {
        loader.hide();
        const { data } = response;
        if (data.status) {
          router.push({ path: "/marketing-automation/user-journey" });
          vmVue.$root.$emit("bv::hide::modal", "confirmation");
          Vue.toasted.show(data.message);
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(error => {
        loader.hide();
        Vue.toasted.show("Catch Error on adding User Journey", error);
      });
  }
};

const getters = {
  triggersList: state => state.triggersList,
  actionsList: state => state.actionsList,
  flowControlsList: state => state.flowControlsList,
  conditionsList: state => state.conditionsList,
  actionDataTypes: state => state.actionDataTypes,
  conditionRules: state => state.conditionRules,
  emailCampaigns: state => state.emailCampaigns,
  smsTemplates: state => state.smsTemplates,
  segments: state => state.segments,
  userJourneyList: state => state.userJourneyList,
  getSelectedStatus: state => state.selectedStatus
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/userJourneyStore.js